const paramForCategory = (category) => {
  return `${category}s`
}

const categoryForParam = (param) => {
  return param.replace(/s+$/, '')
}

export { paramForCategory, categoryForParam }
